import {observer} from "mobx-react-lite";
import React, {useEffect, useState} from "react";
import {useStore} from "../../helpers";
import { FTPBreadCrumbs } from "../../components-new/BreadCrumbs";
import TrieSearch from 'trie-search';
import { PRINT_MEDIA_LANGUAGES } from "./print-media-settings";

const crumbs = [
    {name: 'Media Dashboard', href: '/media', current: false},
    {name: 'Manage Search Terms', href: '#', current: true},

];

export const ManageSearchTerms = observer((props: any) => {

    const rootStore = useStore();
    const {mediaStore} = rootStore;

    //tri-search queries
    const [searchQuery, setSearchQUery] = useState('');
    const [filteredQueries, setFilteredQueries] = useState([])
    const [trie, setTrie] = React.useState(null)

    const [searchTerms, setSearchTerms] = useState([])
    const defaultSearchTerm = {
        query: '',
        lang: ''
    }
    const [st, setSt] = useState(defaultSearchTerm)

    useEffect(() => {
        getSearchQueries();
    }, [])

    const getSearchQueries = async () => {
        const queries = await mediaStore.getAllSearchQueries()
        setSearchTerms(queries['data'])
    }

    const languages = PRINT_MEDIA_LANGUAGES;


    //Trie search
    useEffect(() => {
        const tmpTrie = new TrieSearch(['query', 'lang']);
        tmpTrie.addAll(searchTerms)
        setTrie(tmpTrie)
        if (searchQuery.trim() === '') {
            setFilteredQueries(searchTerms)

            //reset fields when we clear the search query
            setSt(defaultSearchTerm)
        } else {
            setFilteredQueries(trie.get(searchQuery));
        }
        setSt({...st, 'query': searchQuery})
    }, [searchQuery, searchTerms])


    const addSearchTerm = async () => {
        await mediaStore.addNewSearchQuery(st)
        getSearchQueries();
        setSearchQUery('')
    }


    const AddNewSearchTerm = () => {
        return (
            <>
                <div className='my-4'>No such search terms found, please add</div>
                <div className='grid grid-cols-5 gap-2 flex flex-col items-center'>
                    <div className='flex flex-col'>
                        <label htmlFor="query" className="block text-md font-medium text-gray-700">Search Term</label>
                        <input
                            className='border-2 border-gray-300 bg-white h-10 px-3 rounded-lg text-sm focus:outline-none'
                            disabled={true}
                            name='query' type='text' value={searchQuery}/>
                    </div>
                    <div className='flex flex-col'>
                        <label htmlFor="lang" className="block text-md font-medium text-gray-700">Language</label>
                        <select
                            className='border-2 border-gray-300 bg-white h-10 px-3 rounded-lg text-sm focus:outline-none'
                            value={st.lang} onChange={(evt) => {
                            setSt({...st, lang: evt.target.value})
                        }}>
                            <option
                                className='origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none'
                                value={''}>---Select---</option>
                            {
                                Object.keys(languages).map((key, index) => {
                                    const label = languages[key];

                                    return <option
                                        className='origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none'
                                        value={key}>{label}</option>
                                })
                            }
                        </select>
                    </div>
                    <div className='pt-6'>
                        <button className='px-4 py-2 rounded-md bg-indigo-700 text-white'
                                onClick={addSearchTerm}>Save
                        </button>
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            <FTPBreadCrumbs crumbs={crumbs}/>
            <div className='font-bold text-3xl text-gray-800 p-4'>Manage Search Terms</div>
            <div className='p-4'>
                <div className="text-gray-600">
                    <input
                        value={searchQuery}
                        onChange={(evt) => {
                            setSearchQUery(evt.target.value);
                        }}
                        className="border-2 border-gray-300 bg-white h-10 w-80 px-3 rounded-lg text-sm focus:outline-none"
                        type="search" name="search" placeholder="Search Terms"/>
                </div>
                {filteredQueries.length != 0 ?
                    <div className='grid grid-cols-1 md:grid-cols-6 gap-2 mt-4'>
                        {
                            filteredQueries.map((st, index) => {
                                return (
                                    <>
                                        <div className='p-2 rounded-md bg-white shadow-md hover:shadow-lg'
                                             key={index}>
                                            <div className='text-md text-indigo-600 font-bold'>{st.query}</div>
                                            <div className='text-sm text-gray-500'>{languages[st.lang]}</div>
                                        </div>
                                    </>
                                )
                            })
                        }
                    </div> :
                    AddNewSearchTerm()
                }
            </div>
        </>
    );

});